require('../modules/mod.select');

function dynamicSelect() {
	var list_one = [
		{display: "سوال پیش از خرید", value: "1" },
		{display: "اخد راهنمایی", value: "2" },
		{display: "درخواست بروز رسانی محصول", value: "3" },
		{display: "مشکل در لینک دانلود", value: "4" },
		{display: "درخواست تغییر دامنه پشتیبانی", value: "5" },
		{display: "سایر موارد", value: "6" }
	];
	var list_two = [
		{display: "مشکل در اطلاعات", value: "1" },
		{display: "مشکل در لینک دانلود", value: "2" },
		{display: "بروز خطا در ژاکت", value: "3" },
		{display: "مالکیت محصول", value: "4" },
		{display: "عدم پسخگویی فروشنده", value: "5" },
		{display: "مشکلات مالی", value: "6" },
		{display: "سایر موارد", value: "7" }
	];
	var list_three = [
		{display: "پیشنهادات و انتقادات", value: "1" }
	];
	
	function upgradeList(array_list){
		$ChildSelect = $('#child_select');
		/* Clear The Child Select Box Element */
		$ChildSelect.html("");
		/* Append Def Select Box Option */
		$ChildSelect.append("<option disabled='disabled' selected='selected'>انتخاب کنید</option>");
		$(array_list).each(function (i) {
			/* Generate New Options */
			$("#child_select").append("<option value='" + array_list[i].value + "'>" + array_list[i].display + "</option>");
		});
		/* Update Nice Select Plugins */
		$ChildSelect.niceSelect('update')
	}
	
	$("#parent-select").change(function() {
		/* Get Parent Selected Value */
		var parent = $(this).val();
		/* Choose Array and Generate Options */
		switch(parent){
			case '1':
				upgradeList(list_one);
				break;
			case '2':
				upgradeList(list_two);
				break;
			case '3':
				upgradeList(list_three);
				break;
			default:
				$("#child_selection").html('');
				break;
		}
	});
}

$(function() {
	if ($('.page-buyer-ticket').length > 0) {
		dynamicSelect();
	}
});